export const environment = {
  production: false,
  staging: true,
  googleMapsApiKey: 'AIzaSyCEq_Zo1dME6C34Vnz6Xq2RG7hkyu2K-Qc',
  config: {
    basePath: 'https://staging.damagereporter.dk/api/',
    basePathLogo: 'https://staging.damagereporter.dk'
  }
};
